import { Box, Container, Skeleton } from '@frontend-workspace/react-shared-lib';
import { Col, Row } from 'reactstrap';

export function AdminChangeContractSkeleton() {
  return <>
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component='div'
            className='pb-5'>
            <div className='mb-5'>
              <Skeleton animation="wave" height={50} width={200} />
            </div>
            <div className="d-flex flex-row align-items-center flex-wrap">
              <div className='mb-3 mb-xxl-0 me-4'>
                <Skeleton animation="wave" height={50} width={150} />
              </div>
              <div className='mb-3 mb-xxl-0 me-5'>
                <Skeleton animation="wave" height={50} width={150} />
              </div>
              <div className='mb-3 mb-xxl-0'>
                <Skeleton animation="wave" height={50} width={150} />
              </div>
            </div>
            <div className='d-flex justify-content-end'>
              <Skeleton animation="wave" width={150} height={50} />
            </div>
            <Skeleton variant="rectangular" animation="wave" width='100%' height={650} />
          </Box>
        </Col>
      </Row>
    </Container>
  </>
}

export default AdminChangeContractSkeleton;